export default __webpack_public_path__ + "static/media/logo-border-white-92px.d748817d.png";